const ROUTE_PATTERNS = {
    DASHBOARD: '/dashboard',
    GAME_EDIT: '/games/edit/:game_id',
    TASKS_ORGANIZE: '/tasks/organize/:game_id',
    GAMES_PATH: '/games/path/:game_id',
    TEAMS_ORGANIZE: '/teams/organize/:game_id',
    GROUPS_ORGANIZE: '/groups/organize/:game_id',
    GAMES_REWARDS: '/games/rewards/:game_id',
    GAMES_EXPORTS: '/games/exports/:game_id',
    ANSWERS_MONITOR: '/answers/monitor/:game_id',
    GAMES_GREY: '/games/grey/:game_id',
    GAMES_REELS: '/games/reels/:game_id',
    TASKS_LIBRARY: '/tasks/library/:game_id',
    GAMES_STREAM: '/games/stream/:game_id',
    TASKS_STREAM: '/tasks/stream/:game_id/:challenge_id',
    TEAMS_STREAM: '/teams/stream/:game_id/:team_id',
    TEAMS_LEADERBOARD: '/teams/leaderboard/:game_id',
    ANSWERS_SHOW: '/answers/show/:game_id/:id',
    GAMES_SLIDESHOW: '/games/slideshow/:game_id',
    GAMES_PERSONALIZATIONS: '/games/personalizations/:game_id',
    GAMES_ANALYTICS: '/games/analytics/:game_id',
    GAMES_LIVE: '/games/live/:game_id',
    GAMES_DONATE: '/games/donate/:game_id',
    GAMES_NPC: '/games/npc/:game_id',
    GAMES_DESIGNATIONS: '/games/designations/:game_id',
    SIGN_IN: '/sign-in',
    SIGN_UP: '/sign-up',
    MAINTENANCE: '/maintenance',
    RESET_PASSWORD: '/reset-password',
    PRIVACY: '/privacy',
    SERVER_ERROR: '/server-error',
    TERMS: '/terms',
    ROOT: '/',
}

export default ROUTE_PATTERNS;